import * as React from 'react';
export const baremetricsSvg = React.forwardRef(function baremetricsSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#6078FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.63 14.39a3.38 3.38 0 0 1 0 3.22l-4.69 7.74a3.363 3.363 0 0 1-2.955 1.761H11.94a3.361 3.361 0 0 1-2.955-1.762l-1.564-2.586 6.172-5.753 4.47 2.534a1.118 1.118 0 0 0 1.464-.195l6.769-7.223 1.333 2.265Zm-15.068-1.689-6.759 7.296-1.432-2.387a3.378 3.378 0 0 1 0-3.22l4.614-7.74a3.362 3.362 0 0 1 2.955-1.76h8.045a3.36 3.36 0 0 1 2.955 1.762l1.623 2.678-6.044 5.66-4.452-2.533a1.118 1.118 0 0 0-1.505.245Z',
      fill: '#fff',
    }),
  );
});
baremetricsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var baremetrics = {
  category: 'brand',
  colorable: false,
  name: 'baremetrics',
  svg: baremetricsSvg,
};
